// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react"
import { classNames } from "@plasmicapp/react-web"

export function G172Icon(props) {
  const { className, style, title, ...restProps } = props
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 45 31"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",
        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M17.576 30.557l8.944-9.698-8.944-9.7h9.437l4.43 4.712 4.265-4.712h9.108l-8.902 9.66 9.024 9.738h-9.475l-4.39-4.75-4.349 4.75h-9.148zm0-23.747H7.446v4.35h10.13v6.552H7.446v6.016h10.13v6.83H0V0h17.576v6.81z"
        }
        fill={"currentColor"}
      ></path>
    </svg>
  )
}

export default G172Icon
/* prettier-ignore-end */
